define(function(require) {
	const standardCardDefault = require("civicsViews/card_views/standard/defaults");
	const descriptionCardDefault = require("civicsViews/card_views/description/defaults");
	return {
		getConfigsFor:function(instrumentType,portlet,portalConfig){
			var ret = null;
			if(instrumentType == null || portlet == null || portalConfig == null){
				return ret;
			}
			instrumentType = instrumentType.toLowerCase();
			if(instrumentType=="buildingpermit"){
				instrumentType = "building";
			} else if(instrumentType == "case"){
				instrumentType = "codeenforcement";
			} else if(instrumentType == "useapplication"){
				instrumentType = "use";
			}
			portlet = portlet.toLowerCase();
			$.each(portalConfig,function(key,value){
				if(key.toLowerCase() == instrumentType){
					if(value.fields){
						$.each(value.fields,function(k,v){
							if(k.toLowerCase() == portlet){
								ret = v;
								//break the each
								return false;
							}
						});
					}
					//break the each
					return false;
				}
			});
			return ret;
		},
		getRelatedTypesFor:function(instrumentType,portlet,portalConfig){
			var ret = null;
			if(instrumentType == null || portlet == null || portalConfig == null){
				return ret;
			}
			instrumentType = instrumentType.toLowerCase();
			if(instrumentType=="buildingpermit"){
				instrumentType = "building";
			} else if(instrumentType == "case"){
				instrumentType = "codeenforcement";
			} else if(instrumentType == "useapplication"){
				instrumentType = "use";
			}
			portlet = portlet.toLowerCase();
			$.each(portalConfig,function(key,value){
				if(key.toLowerCase() == instrumentType){
					if(value.relatedRecordTypes){
						ret = value.relatedRecordTypes;
					}
					//break the each
					return false;
				}
			});
			return ret;
		},
		//expects the next level down after the fields object, like myProjects/relatedRecords/etc
		getSelectsFor:function(fields){
			var selects = [
				'applicationType', //needed for base constraints, used if no milestone
				'currentMilestone' //needed for milestone constraints
			];
		$.each(fields,function(key,value){
			$.each(value,function(index,item){
				selects.push(item);
			});
		});

			return selects;

		},
		//The idea here is to combine the portlet config,constraints, and instrument Data into the cards JSON for the row
		buildCardJSON:function(instrumentData,config, instrumentType, mappings){
			var cards = [];
			var self = this;

			var sectionID = ("cardId" +  Math.floor(Math.random()*100000));

			//iterate over sections. push onto card array in order received from server
			$.each(config, function(cardName,fields){
				cardName = cardName.toLowerCase();
				var newCard;
				//TODO - figure out how to generalize this. It's specific to my Projects right now... Or make this the standard for all cards?
				if(cardName == 'summary'){
					newCard = self.buildDescriptionCardJSON(instrumentData, cardName, fields, instrumentType, mappings);
				} else {
					var defaultField = standardCardDefault.field;
					newCard = self.buildStandardCardJSON(instrumentData, cardName, fields, instrumentType, mappings, defaultField);
					//don't show cards that have no fields in them.
					if(newCard.data.length == 0){
						newCard = null;
					}
				}
				if(newCard!=null){
					newCard.sectionID = sectionID;
					cards.push(newCard);
				}
			});
			return cards;
		},
		buildDescriptionCardJSON:function(instrumentData, cardName, fields, instrumentType, mappings){
			//make a copy by value
			var newDescriptionCard = JSON.parse(JSON.stringify(descriptionCardDefault.card));

			//this will have multiple copies made, so it will be JSON'd later
			var defaultField = descriptionCardDefault.field;

			newDescriptionCard['is'+cardName.charAt(0).toUpperCase() + cardName.slice(1)] = true;
			newDescriptionCard.cardClass = cardName+'-card';
			newDescriptionCard.card = this.buildStandardCardJSON(instrumentData, cardName, fields, instrumentType, mappings, defaultField);

			//remove properties that don't apply to a sub card
			delete newDescriptionCard.card['is'+cardName.charAt(0).toUpperCase() + cardName.slice(1)];
			delete newDescriptionCard.card.cardClass;
			delete newDescriptionCard.card.title;

			//TODO: Set up menu options
			delete newDescriptionCard.menu;
			return newDescriptionCard;

		},
		buildStandardCardJSON:function(instrumentData, cardName, fields, instrumentType, mappings, defaultField){
			var constraints;
			if(instrumentData.constraints && instrumentData.constraints.constraints){
				constraints = instrumentData.constraints.constraints;
			}
			//make a copy by value
			var newStandardCard = JSON.parse(JSON.stringify(standardCardDefault.card));
			newStandardCard['is'+cardName.charAt(0).toUpperCase() + cardName.slice(1)] = true;
			newStandardCard.cardClass = cardName+'-card';
			newStandardCard.title = cardName;//need to localize
			//TODO - this is my projects specific. need to generalize this somehow. This could probably be post processing in the parent portlet
			if(cardName == 'fees' || cardName == 'summary'){
				newStandardCard.numColumns = 1;
			}
			//set a bool to simplify checking for certain card types later down the road.
			//for example, summary will become isSummary = true;
			newStandardCard['is'+cardName.charAt(0).toUpperCase() + cardName.slice(1)] = true;
			newStandardCard.cardClass = cardName+'-card';
			var self = this;
			$.each(fields, function(index,configAttribute){
				var constraint = self.getValueFromMappings(configAttribute,instrumentType,"constraint", mappings);
				if (!self.showField(constraint,constraints)){
					//return true to break out of this iteration. This value should not be displayed
					return true;
				}
				//copy the default field json by value
				var field = JSON.parse(JSON.stringify(defaultField));
				field.configAttributeName = configAttribute;
				field.localizedDescription = self.getValueFromMappings(configAttribute, instrumentType, "friendlyName", mappings);

				//remove this, since we're using the localized one.
				delete field.description;

				field.value = self.getValue(instrumentData, instrumentType, configAttribute, constraints, constraint, mappings);
				var format = self.getValueFromMappings(configAttribute, instrumentType, "formatType",mappings);
				if(format){
					field.dataType = format;
				}
				newStandardCard.data.push(field);
			});
			return newStandardCard;
		},
		//returns true if the field as a WHOLE should be shown. some fields may be tied to multiple constraints. as long as one of those constraints is set to show, the field will show.
		showField:function(constraint,constraints){
			var ret = true;
			if(constraint!=null && constraint!='' && constraints!=null){
				if(Array.isArray(constraint)){
					var numShow = 0;
					$.each(constraint,function(index, con){
						//if any of the constraints in the array are set to show, we'll show the field. values will be checked individually in the getValue function.
						if(constraints[con] != null && constraints[con].shown === true){
							numShow++;
						}
					});
					if(numShow<=0){
						ret = false;
					}
				} else if(constraints[constraint] != null && constraints[constraint].shown === false){
					//this field should not be shown.
					ret = false;
				}
			}
			return ret;
		},
		getValue:function(instrumentData, instrumentType, configAttribute, constraints, constraint, mappings){
			var ret = "";
			var instrumentAttribute = this.getValueFromMappings(configAttribute, instrumentType, "instrument", mappings);
			instrumentAttribute = instrumentAttribute ? instrumentAttribute : '';

			//if the instrumentAttribute is an array, we need to pull multiple fields and combine them
			if (Array.isArray(instrumentAttribute)) {
				var delimiter = this.getValueFromMappings(configAttribute, instrumentType, "delimiter", mappings);
				for (var i = 0; i < instrumentAttribute.length; i++) {
					if (!_.isEmpty(constraint) && constraints != null && constraints[constraint[i]] != null && constraints[constraint[i]].shown === false) {
						//this instrumentAttribute shouldn't be shown according to the constraints. continue to skip it.
						continue;
					}
					var val;
					if (instrumentAttribute[i].indexOf('.') > 0) {
						var split = instrumentAttribute[i].split('.');
						var curAttribute = instrumentData;
						for (let j = 0; j < split.length; j++) {
							curAttribute = curAttribute[split[j]];
						}
						val = curAttribute;
					} else {//otherwise, just assign the instrumentAttribute[i]
						val = instrumentData[instrumentAttribute[i]];
					}
					if (typeof val == "number" && !isNaN(val)) {
						val = val.toString();
					}
					if (!_.isEmpty(val)) {
						if (ret != "") {
							ret += delimiter;
						}
						ret += val;
					}
				}

			} else if (instrumentAttribute.indexOf('.') > 0) {
				var split = instrumentAttribute.split('.');
				var curAttribute = instrumentData;
				for (let i = 0; i < split.length; i++) {
					curAttribute = curAttribute[split[i]];
				}
				ret = curAttribute;
			} else {//otherwise, just assign the instrumentAttribute
				ret = instrumentData[instrumentAttribute];
			}

			return ret;
		},
		getValueFromMappings:function(configName, instrumentType, attribute, mappings){
			var val;
			//all parameters are required.
			if(mappings && instrumentType && configName && attribute){
				instrumentType = instrumentType.toLowerCase();
				//TODO: REMOVE THIS NEXT LINE OF CODE - temp code to match the current RS, they are changing to make this obsolete
				configName = configName.charAt(0).toLowerCase() + configName.slice(1);
				//TODO END
				//check for instrument specific mappings first
				if(mappings[instrumentType] && mappings[instrumentType][configName]){
					val = mappings[instrumentType][configName][attribute];
					//otherwise look at the common mappings
				} else if(mappings.common && mappings.common[configName]){
					val = mappings.common[configName][attribute];
				}
			}
			return val;
		},
		getRelatedRecordTypesFilter: function (instrumentType, cardConfigAttribute, cardConfig) {
			let relatedRecordConfig = this.getRelatedTypesFor(instrumentType, cardConfigAttribute, cardConfig);
			var ret = [];
			if (Array.isArray(relatedRecordConfig)) {
				$.each(relatedRecordConfig, (index, type) => {
					switch (type.toLowerCase()) {
						case 'building':
							type = 'buildingapplication';
							break;
						case 'codeenforcement':
							type = 'case';
							break;
						case 'planning':
							type = 'planningapplication';
							break;
						case 'project':
							type = 'projectapplication';
							break;
						case 'use':
							type = 'useapplication';
							break;
						default:
							break;
					}
					var filter = {
						operator: 'Equal',
						property: 'instrumentType',
						value: type
					};
					ret.push(filter);
				});
			}
			return ret;
		}
	};
});
